import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';

export const materialAssemblyNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('materialAssembly'),
    controlValues: z.object({
        // materialsToAssemble: z.array(z.string()).min(1), // TODO: Implement dynamic sockets to handle variable number of materials
    }),
});
export interface MaterialAssemblyNodeCfgSchema extends z.infer<typeof materialAssemblyNodeCfgSchema> {}

export const materialAssemblyNodeCfg = {
    controlSockets: {
        inputs: () => ({
            trigger: 'event',
        }),
        outputs: () => ({
            good: 'event',
            bad: 'event',
        }),
    },
    dataSockets: {
        outputs: () => ({}),
        inputs: (): Record<'parentMaterial' | 'componentMaterialId', 'string'> => {
            return {
                parentMaterial: 'string',
                // ...Object.fromEntries(cfg.controlValues.materialsToAssemble.map((materialId) => [ materialId, 'string' ])), // TODO: Implement dynamic sockets to handle variable number of materials
                componentMaterialId: 'string',
            };

        },
    },
} satisfies NodeSocketCfg<MaterialAssemblyNodeCfgSchema>;
